const getters = {
  token: state => {
    return state.token
  },
  customerId: state => {
    return state.customerId
  },
  userId: state => {
    return state.userId
  },
  orderId: state => {
    return state.orderId
  },
  login: state => {
    return state.login
  },
  userInfo: state => {
    return state.userInfo
  },
  orderInfo: state => {
    return state.orderInfo
  },
  bookInfo: state => {
    return state.bookInfo
  },
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js